import dayjs from 'dayjs'
import {
  allAvailableEventTypes,
  displayNamesOfEventTypes,
  paymentMethodTitleMap,
} from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { getYearDifferenceBetweenTwoDates } from 'src/mentor/helpers/utilityFunctions'

const eventTypeToEventMentorType = {
  [allAvailableEventTypes.consultation]: 'Consultant',
  [allAvailableEventTypes.therapySession]: 'Therapist',
  [allAvailableEventTypes.screening]: 'Screener',
}

export function getStringsForPrintReceipt(langCode) {
  let strings = {
    bill: 'Bill',
    receipt: 'Receipt',
    mobile: 'Mobile',
    tokenNo: 'Token No',
    modeOfPayment: 'Mode of Payment',
    appointmentDateAndTime: 'Appointment Date & Time',
    patientName: 'Patient Name',
    ageSex: 'Age/Sex', // ling/aayu (hi)
    lastVisited: 'Last Visited',
    description: 'Description',
    grossAmount: 'Gross Amount',
    disc: 'Disc',
    netAmount: 'Net Amount',
    mentorName: '{mentorName} Name',
    eventCharge: '{eventName} Charge',
    patientNumber: 'Patient Number',
    email: 'Email',
    patientMobile: 'Patient Mobile',
    patientEmail: 'Patient Email',
    printContact: 'Print contact on receipt',
    clinicPhone: 'Clinic phone',
    notApplicable: 'Not Applicable',
  }

  switch (langCode) {
    case 'hi':
      strings.bill = 'बिल'
      strings.receipt = 'रसीद'
      strings.mobile = 'मोबाइल'
      strings.tokenNo = 'टोकन न०'
      strings.modeOfPayment = 'भुगतान का माध्यम'
      strings.appointmentDateAndTime = 'अपॉइंटमेंट की तिथि और समय'
      strings.patientName = 'मरीज़ का नाम'
      strings.ageSex = 'आयु/लिंग'
      strings.lastVisited = 'पिछली विज़िट'
      strings.description = 'विवरण'
      strings.grossAmount = 'कुल राशि'
      strings.disc = 'छूट'
      strings.netAmount = 'नेट राशि'
      strings.mentorName = '{mentorName} नाम'
      strings.eventCharge = '{eventName} शुल्क'
      strings.patientNumber = 'मरीज़ का पहचानकर्ता'
      strings.email = 'ईमेल'
      strings.patientMobile = 'मरीज़ का मोबाइल'
      strings.patientEmail = 'मरीज़ का ईमेल'
      strings.printContact = 'रसीद में संपर्क प्रिंट करें'
      strings.clinicPhone = 'क्लिनिक फ़ोन'
      strings.notApplicable = 'लागू नहीं'
      break
    default:
      break
  }
  return strings
}

export function getEventTypeToMentorType(eventType, langCode, addLinkingVerb = false) {
  let nameTypes = { ...eventTypeToEventMentorType } // Clone the object to prevent direct mutation

  // TODO: addLinkingVerb implement
  switch (langCode) {
    case 'hi':
      nameTypes[allAvailableEventTypes.consultation] = 'डॉक्टर का'
      nameTypes[allAvailableEventTypes.therapySession] = 'थैरेपिस्ट का'
      nameTypes[allAvailableEventTypes.screening] = 'स्क्रीनर का'
      break
    default:
      // No changes to English, we use the default mapping
      break
  }

  return nameTypes?.[eventType]
}

export function getEventTypeDisplayName(eventType, langCode, addLinkingVerb = false) {
  let displayNames = { ...displayNamesOfEventTypes }

  switch (langCode) {
    case 'hi':
      displayNames[allAvailableEventTypes?.oneOnOne] = 'एक-पर-एक का'
      displayNames.interview = 'इंटरव्यू सत्र का'
      displayNames.consultation = 'परामर्श'
      displayNames[allAvailableEventTypes?.therapySession] = 'थेरेपी सेशन का'
      displayNames.webinar = 'वेबिनार का'
      displayNames.screening = 'स्क्रीनिंग का'
      break
    default:
      break
  }

  return displayNames?.[eventType]
}

export function getPaymentMethodTitle(paymentMethod, langCode) {
  let paymentMethods = { ...paymentMethodTitleMap }

  switch (langCode) {
    case 'hi':
      paymentMethods.cash = 'नकद'
      paymentMethods.debit_and_credit_cards = 'डेबिट और क्रेडिट कार्ड'
      paymentMethods.phonepe = 'फोनपे'
      paymentMethods.google_pay = 'गूगल पे'
      paymentMethods.paytm = 'पेटीएम'
      paymentMethods.other_upi = 'अन्य यूपीआई'
      paymentMethods.aumhum = 'ओमहम द्वारा एकत्रित'
      break
    default:
      break
  }

  return paymentMethods?.[paymentMethod]
}

export function getGenderString(genderString, langCode) {
  let genders = {
    male: 'Male',
    female: 'Female',
    nonBinary: 'Non Binary',
  }

  switch (langCode) {
    case 'hi':
      genders.male = 'पुरुष'
      genders.female = 'महिला'
      genders.nonBinary = 'गैर-द्विआधारी'
      break
    default:
      break
  }

  return genders?.[genderString]
}

export function getPatientAgeWhenEventWasCreated(patientDobString, dateTimeWhenRecordWasTaken) {
  const patientTodaysAge = getAgeFromDobWithTime(patientDobString) || 'NA'
  
  if (patientTodaysAge !== 'NA') {
    return (
      patientTodaysAge -
      getYearDifferenceBetweenTwoDates(dayjs(), dayjs.utc(dateTimeWhenRecordWasTaken).local())
    )
  }
  return 'NA'
}
